import React from "react"
import PropTypes from "prop-types"
import { DismissButton } from "./dismiss-button"
import CanvaLogo from "./canva-logo.svg"
import GiphyLogo from "./giphy-logo.svg"
import PinterestLogo from "./pinterest-logo.svg"

export const MediaGalleryLogos = ({ onDismiss }) => (
  <div className="flex items-center gap-2">
    <CanvaLogo className="w-6 h-6" />
    <GiphyLogo className="w-6 h-6" />
    <PinterestLogo className="w-6 h-6" />
    {onDismiss && <DismissButton onDismiss={onDismiss} className="ml-auto" />}
  </div>
)

MediaGalleryLogos.propTypes = {
  onDismiss: PropTypes.func
}
